/* ARK Products — ブログ本文の連続画像スワイパー（enhancement）
   <div class="ark-swiper"> 内の複数 <figure> を横スワイプ化し、ドット・矢印を付ける。
   コア（スワイプ）は CSS だけで成立するため、JS が無効でも縦横スクロールで閲覧可能。 */
(function () {
  'use strict';

  function init() {
    var swipers = document.querySelectorAll('.ark-swiper');
    for (var i = 0; i < swipers.length; i++) {
      enhance(swipers[i]);
    }
  }

  function enhance(track) {
    if (track.getAttribute('data-ark-swiper-ready')) return;
    var slides = track.querySelectorAll(':scope > figure, :scope > .ark-swiper__slide');
    if (slides.length < 2) return; // 1枚ならスワイパー不要
    track.setAttribute('data-ark-swiper-ready', '1');

    var wrap = document.createElement('div');
    wrap.className = 'ark-swiper__wrap';
    track.parentNode.insertBefore(wrap, track);
    wrap.appendChild(track);

    var prev = makeArrow('prev', '‹', '前の画像');
    var next = makeArrow('next', '›', '次の画像');
    wrap.appendChild(prev);
    wrap.appendChild(next);

    var dots = document.createElement('div');
    dots.className = 'ark-swiper__dots';
    var dotEls = [];
    for (var i = 0; i < slides.length; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ark-swiper__dot';
      dot.setAttribute('aria-label', (i + 1) + '枚目へ');
      bindDot(dot, i);
      dots.appendChild(dot);
      dotEls.push(dot);
    }
    wrap.appendChild(dots);

    function bindDot(dot, idx) {
      dot.addEventListener('click', function () { scrollToIndex(idx); });
    }
    function gap() {
      var cs = getComputedStyle(track);
      var g = parseFloat(cs.columnGap || cs.gap || '0');
      return isNaN(g) ? 0 : g;
    }
    function slideWidth() {
      return slides[0].getBoundingClientRect().width + gap();
    }
    function currentIndex() {
      var w = slideWidth();
      return w ? Math.round(track.scrollLeft / w) : 0;
    }
    function behavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }
    function scrollToIndex(idx) {
      idx = Math.max(0, Math.min(slides.length - 1, idx));
      track.scrollTo({ left: idx * slideWidth(), behavior: behavior() });
    }
    function update() {
      var idx = currentIndex();
      for (var i = 0; i < dotEls.length; i++) {
        dotEls[i].classList.toggle('ark-swiper__dot--active', i === idx);
      }
    }

    prev.addEventListener('click', function () { scrollToIndex(currentIndex() - 1); });
    next.addEventListener('click', function () { scrollToIndex(currentIndex() + 1); });
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();

    // スワイプ（ドラッグ）中の誤タップで拡大リンク（<a target="_blank">）を開かない
    var downX = 0, downY = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      downX = e.clientX; downY = e.clientY; moved = false;
    }, { passive: true });
    track.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) moved = true;
    }, { passive: true });
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  function makeArrow(dir, glyph, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ark-swiper__arrow ark-swiper__arrow--' + dir;
    b.setAttribute('aria-label', label);
    b.textContent = glyph;
    return b;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
